import { render, staticRenderFns } from "./DomainsForm.vue?vue&type=template&id=173f7419"
import script from "./DomainsForm.vue?vue&type=script&lang=js"
export * from "./DomainsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports